export default __webpack_public_path__ + "static/media/default-banner-bg.4238ee22.jpg";